export enum HouseVillaPropertyDetailMenuEnum {
  overview = 11,
  transactionHistory
}
